import * as RadixAvatar from '@radix-ui/react-avatar';

import { cx } from '@/shared/lib/cx';

import { initials } from './initials';

import styles from './Avatar.module.scss';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg';

const SIZE: Record<AvatarSize, string> = {
  xs: styles['avatar--xs'] ?? '',
  sm: styles['avatar--sm'] ?? '',
  md: styles['avatar--md'] ?? '',
  lg: styles['avatar--lg'] ?? '',
};

export interface AvatarProps {
  /** Имя человека: из него берутся инициалы и цвет, если картинки нет. */
  name: string;
  src?: string | undefined;
  size?: AvatarSize;
  /** Зелёная точка «онлайн» (presence, фаза 2). */
  online?: boolean;
  className?: string;
}

/**
 * Цвет из имени — один и тот же для одного человека на всех экранах.
 *
 * Оттенок берётся из хеша имени, насыщенность и яркость фиксированы под
 * тёмный фон, так что любой оттенок остаётся читаемым и не спорит с
 * акцентом.
 */
function hueOf(name: string): number {
  let hash = 0;

  for (const char of name) {
    hash = (hash * 31 + char.codePointAt(0)!) % 360;
  }

  return hash;
}

export function Avatar({ name, src, size = 'md', online = false, className }: AvatarProps) {
  return (
    <span className={cx(styles['avatar'], SIZE[size], className)} title={name}>
      <RadixAvatar.Root className={styles['avatar__root']}>
        {src !== undefined && (
          <RadixAvatar.Image className={styles['avatar__image']} src={src} alt={name} />
        )}
        <RadixAvatar.Fallback
          className={styles['avatar__fallback']}
          style={{ '--avatar-hue': hueOf(name) } as React.CSSProperties}
          delayMs={src === undefined ? 0 : 300}
        >
          {initials(name)}
        </RadixAvatar.Fallback>
      </RadixAvatar.Root>
      {online && <span className={styles['avatar__online']} aria-label="в сети" />}
    </span>
  );
}
